<template>
  <div class="commentary" :style="{ height: wrap ? `${wrap}px` : '100%' }">
    <div
      class="commentary-wrapper"
      ref="comment"
      v-if="qComment.value || qComment.audio || qComment.video"
      :class="{ move: move }"
      :style="{
        bottom: `${safeAreaBottom}px`,
        transform: `translateY(${position + presenHeight}px)`,
      }"
    >
      <button
        @mousedown="dragStart"
        @touchstart="dragStart"
        type="button"
        class="btn btn-commentary"
        id="test1"
      >
        解説
      </button>
      <div class="comment" :style="{ height: `${presenHeight}px` }">
        <div
          :style="{ height: `${position * -1 - 20}px` }"
          style="overflow: auto"
        >
          <div
            class="q-option-container"
            v-if="qComment.audio || qComment.video"
          >
            <img
              src="@/assets/img/btn_sound.png"
              v-if="qComment.audio"
              :key="qComment.audio"
              class="q-btn_sound q-option"
              alt="音声"
              @click="openModalSound"
              @touchstart="openModalSound"
              width="113"
              height="58"
            />
            <img
              src="@/assets/img/btn_movie.png"
              v-if="qComment.video"
              :key="qComment.video"
              class="q-btn_movie q-option"
              alt="動画"
              @click="openModalMovie"
              @touchstart="openModalMovie"
              width="113"
              height="58"
            />
          </div>
          <div
            class="presentationWrap"
            :class="{ 'with-option': qComment.audio || qComment.video }"
          >
            <div
              class="presentation"
              ref="presentationWrap"
              v-if="qComment.type === 'text'"
              v-html="qComment.value.split('\n').join('<br/>')"
              :style="{
                textAlign: qComment.align,
                fontSize: qComment.fontZoom ? `${qComment.fontZoom}em` : '1em',
              }"
            ></div>
            <div
              class="presentation-block"
              ref="presentationWrap"
              v-if="qComment.type === 'html'"
            >
              <iframe
                :src="`${setting.path}${qComment.value}`"
                ref="iframe"
                @load="iframeInit"
                frameborder="0"
              ></iframe>
            </div>
            <div v-else-if="qComment.type === 'image'" ref="presentationWrap">
              <imgSwipe
                class="presentation-block"
                :src="`${setting.path}${qComment.value}`"
                @imgLoaded="imgLoaded"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <AudioModal
      v-if="openAudio"
      :src="`${setting.path}${qComment.audio}`"
      :config="this.config"
      :id="`c_${qComment.audio}`"
      title="解説音声"
      @closemodal="closeModalSound"
    />
    <VideoModal
      v-if="openVideo"
      :src="`${setting.path}${qComment.video}`"
      :config="this.config"
      title="解説動画"
      @closemodal="closeModalMovie"
    />
  </div>
</template>

<script>
/* eslint-disable no-console */
import ImgSwipe from './imgSwipeComment.vue';
import VideoModal from './Modal/videoModal.vue';
import AudioModal from './Modal/audioModal.vue';

export default {
  name: 'comment',
  props: {
    setting: Object,
    config: Object,
    qComment: Object,
    gap: Number,
    wrap: Number,
  },
  components: {
    ImgSwipe,
    VideoModal,
    AudioModal,
  },
  data() {
    return {
      commentShow: false,

      dragging: false,
      initPosition: { x: 0, y: 0 },
      position: 0,
      commentInitPosition: 0,

      move: false,
      isDragTimer: 0,
      presenHeight: null,

      openAudio: false,
      openVideo: false,
    };
  },
  mounted() {
    console.log('mounted');
    window.addEventListener('resize', this.commentInit);
    window.addEventListener('touchmove', this.dragMove, { passive: false });
    window.addEventListener('mousemove', this.dragMove, { passive: false });

    window.addEventListener('touchend', this.dragEnd, { passive: false });
    window.addEventListener('mouseup', this.dragEnd, { passive: false });
    if (this.qComment) {
      if (this.qComment.type !== 'image') {
        this.$nextTick(() => {
          this.commentInit();
        });
      }
    }
  },
  beforeDestroy() {
    console.log('destroy');
    window.removeEventListener('resize', this.commentInit);
    window.removeEventListener('touchmove', this.dragMove);
    window.removeEventListener('mousemove', this.dragMove);

    window.removeEventListener('touchend', this.dragEnd);
    window.removeEventListener('mouseup', this.dragEnd);
  },
  computed: {
    safeAreaBottom() {
      if (CSS.supports('padding-left: env(safe-area-inset-left)')) {
        const div = document.createElement('div');
        div.style.paddingBottom = 'env(safe-area-inset-bottom)';

        // DOM追加
        div.style.display = 'none';
        document.body.appendChild(div);

        // スタイル取得
        const style = window.getComputedStyle(div);
        const bottom = parseInt(style.paddingBottom, 10);

        return bottom;
      }
      return 0;
    },
  },
  methods: {
    doMute() {
      setTimeout(() => {
        console.log('mute ?');
        this.$refs.myAudio.muted = !this.config.audio;
      }, 500);
    },
    commentToggle() {
      if (this.dragging) {
        this.dragging = false;
        return;
      }
      console.log(this.$refs.comment.clientHeight);
      this.commentShow = !this.commentShow;
      if (this.commentShow) {
        this.showComment();
      } else {
        this.commentInit();
      }

      setTimeout(() => {
        this.move = false;
      }, 500);
    },
    iframeInit() {
      this.presenHeight =
        this.$refs.iframe.contentWindow.document.documentElement.scrollHeight +
        0;
      this.commentInit();
    },

    openModalSound() {
      this.openAudio = true;
    },

    closeModalSound() {
      console.log('close sound');
      this.openAudio = false;
    },
    openModalMovie() {
      this.openVideo = true;
    },
    closeModalMovie() {
      console.log('close');
      this.openVideo = false;
    },

    imgLoaded(e) {
      console.log('IMG LOADED : ');
      console.log(e);
      this.$nextTick(() => {
        this.commentInit();
      });
    },
    commentInit() {
      console.log('comment init');
      this.$emit('hidden');
      this.commentShow = false;
      this.openVideo = false;
      this.openAudio = false;
      this.presenHeight = Math.max(
        this.presenHeight,
        this.$refs.presentationWrap.clientHeight + 120,
        240,
      );

      // this.$set(this.commentPos, 'maxHeight', 'auto');

      // this.$set(this.commentPos, 'height', 'auto');

      this.$nextTick(() => {
        this.presenHeight = Math.min(
          window.innerHeight - 120,
          this.presenHeight,
        );
        console.log(this.$refs.comment.clientHeight);
        /*
        this.$set(
          this.commentPos,
          'maxHeight',
          `${this.$refs.comment.clientHeight}px`,
        );
        this.$set(this.commentPos, 'bottom', `0px`);
        this.$set(this.commentPos, 'height', `0px`);
        */
        this.position = 0;
        /*
        this.$set(
          this.commentPos,
          'transform',
          `translateY(${this.position}px)`,
        );
        */
      });
    },
    showComment() {
      this.$emit('show');
      console.log('show Comment');
      this.commentShow = true;
      this.position = this.presenHeight * -1;
      /*
      if (parseFloat(this.commentPos.height) <= 0) {
        this.$set(this.commentPos, 'height', `${this.commentPos.maxHeight}`);
      }

      if (
        parseFloat(this.commentPos.maxHeight) <=
        parseFloat(this.commentPos.height)
      ) {
        this.$set(this.commentPos, 'height', this.commentPos.maxHeight);

        this.commentInitPosition = parseFloat(this.commentPos.height) * -1;
        this.position = parseFloat(this.commentPos.height) * -1;
      }
      */
    },
    dragStart(e) {
      this.$emit('show');
      console.log('drag start');

      this.isDragTimer = Date.now();

      if (e.target.className.indexOf('pswp') === -1) {
        let point;
        this.dragging = true;
        if (e.touches) {
          point = e.changedTouches[0];
        } else {
          point = e;
        }
        e.preventDefault();
        e.stopPropagation();

        this.initPosition = { x: point.pageX, y: point.pageY };
      }
      this.commentInitPosition = this.position;
    },
    dragMove(e) {
      if (this.dragging) {
        e.preventDefault();
        e.stopPropagation();
        console.log('dragging');
        let point;
        this.dragging = true;
        if (e.touches) {
          point = e.changedTouches[0];
        } else {
          point = e;
        }

        const pos =
          this.commentInitPosition + point.pageY - this.initPosition.y;
        if (pos < this.presenHeight * -1) {
          this.position = this.presenHeight * -1;
        } else {
          this.position = pos;
        }

        // this.$set(this.commentPos, 'height', `${this.position * -1}px`);
      }
    },
    dragEnd(e) {
      let point;
      if (e.touches) {
        point = e.changedTouches[0];
      } else {
        point = e;
      }

      const p = Math.abs(this.initPosition - point.pageY);

      if (Date.now() - this.isDragTimer < 200 || p < 10) {
        this.dragging = false;
        this.commentToggle();
      }
      if (this.dragging) {
        e.preventDefault();
        e.stopPropagation();
        console.log('dragEnd');
        setTimeout(() => {
          this.dragging = false;
        }, 10);
        if (this.position * -1 <= 50) {
          this.commentInit();
        }
      }
    },
  },
  watch: {
    wrap() {
      console.log('wrapping changed');
      this.commentInit();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
video {
  width: 100%;
}

.commentary {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  /* bottom: 0; */
  /* left: 0; */
  pointer-events: none;

  overflow: hidden;
}

.commentary-wrapper * {
  pointer-events: all;
}

.commentary-wrapper {
  /*  position: fixed; */
  /* max-height: calc(100% - 140px); */
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  /* margin-top: 100%; */
  width: 100%;
  height: auto;
  left: 0;
  bottom: 0;
  z-index: 1010;
}

.commentary-wrapper.move {
  transition: 0.2s all;
}

.comment {
  width: 95%;
  height: auto;
  background: #fff;

  box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.35);
  overflow: auto;
  border-radius: 10px 10px 0 0;

  margin: 0;
  top: 2em;
  padding: 10px;

  max-height: 100%;

  overflow: auto;
  z-index: 1015;
}

.presentationWrap {
  position: relative;
  height: 100%;
}

.presentationWrap.with-option {
  height: calc(100% - 60px);
}

.presentation {
  margin: 0 0 30px 0;
  position: absolute;
  width: 100%;
}

.presentation-block {
  margin: 0 0 30px 0;
  position: relative;
  width: 100%;
  height: 100%;
}

.q-option-container {
  position: relative;
  width: 100%;
  text-align: right;
  padding: 0;
  margin: 0;
}

iframe {
  width: 100%;
  height: 100%;
}
</style>
